import React from "react";
import { useCheckout } from "../hooks/useCheckout";
import "./CheckoutForm.css";

const CheckoutForm = () => {
  const {
    form,
    errors,
    loading,
    serverError,
    handleChange,
    handleSubmit,
    AWARD_CATEGORIES,
  } = useCheckout();

  return (
    <div className="checkout-wrapper">
      <div className="checkout-card">
        {/* Header */}
        <div className="checkout-header">
          <div className="trophy-icon">🏆</div>
          <h1 className="checkout-title">FAMAS AWARDS</h1>
          <p className="checkout-subtitle">Complete your payment to vote your Contestant</p>
        </div>

        {/* Server Error Banner */}
        {serverError && (
          <div className="error-banner" role="alert">
            <span className="error-banner-icon">⚠</span>
            <span>{serverError}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="checkout-form" noValidate>

          {/* Full Name */}
          <div className={`field-group ${errors.full_name ? "has-error" : ""}`}>
            <label htmlFor="full_name" className="field-label">
              Full Name <span className="required">*</span>
            </label>
            <input
              id="full_name"
              type="text"
              name="full_name"
              value={form.full_name}
              onChange={handleChange}
              placeholder="e.g. John Doe"
              className="field-input"
              disabled={loading}
              autoComplete="name"
            />
            {errors.full_name && <span className="field-error">{errors.full_name}</span>}
          </div>

          {/* Award Category */}
          <div className={`field-group ${errors.award_category ? "has-error" : ""}`}>
            <label htmlFor="award_category" className="field-label">
              Award Category <span className="required">*</span>
            </label>
            <div className="select-wrapper">
              <select
                id="award_category"
                name="award_category"
                value={form.award_category}
                onChange={handleChange}
                className="field-select"
                disabled={loading}
              >
                <option value="">— Select a category —</option>
                {AWARD_CATEGORIES.map((cat) => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
              <span className="select-arrow">▾</span>
            </div>
            {errors.award_category && (
              <span className="field-error">{errors.award_category}</span>
            )}
          </div>

          {/* Email */}
          <div className={`field-group ${errors.email ? "has-error" : ""}`}>
            <label htmlFor="email" className="field-label">
              Email Address <span className="required">*</span>
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className="field-input"
              disabled={loading}
              autoComplete="email"
            />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          {/* Amount */}
          <div className={`field-group ${errors.amount ? "has-error" : ""}`}>
            <label htmlFor="amount" className="field-label">
              Amount (₦) <span className="required">*</span>
            </label>
            <div className="input-prefix-wrapper">
              <span className="input-prefix">₦</span>
              <input
                id="amount"
                type="number"
                name="amount"
                value={form.amount}
                onChange={handleChange}
                placeholder="0.00"
                className="field-input with-prefix"
                disabled={loading}
                min="1"
                step="any"
              />
            </div>
            {errors.amount && <span className="field-error">{errors.amount}</span>}
          </div>

          {/* Contestant Number */}
          <div className={`field-group ${errors.contestant_number ? "has-error" : ""}`}>
            <label htmlFor="contestant_number" className="field-label">
              Contestant Number <span className="required">*</span>
            </label>
            <input
              id="contestant_number"
              type="text"
              name="contestant_number"
              value={form.contestant_number}
              onChange={handleChange}
              placeholder="e.g. C-001"
              className="field-input"
              disabled={loading}
            />
            {errors.contestant_number && (
              <span className="field-error">{errors.contestant_number}</span>
            )}
          </div>

          {/* Submit */}
          <button
            type="submit"
            className={`submit-btn ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner" />
                Creating Payment Link…
              </>
            ) : (
              <>
                <span>Pay Now</span>
                <span className="btn-arrow">→</span>
              </>
            )}
          </button>

          <p className="secure-note">
            <span>🔒</span> Secured by Flutterwave
          </p>
        </form>
      </div>
    </div>
  );
};

export default CheckoutForm;